import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  @keyframes fadeInFromNone {\n    0% {\n      display: none;\n      opacity: 0;\n    }\n\n    1% {\n      display: flex;\n      opacity: 0;\n    }\n\n    100% {\n      display: flex;\n      opacity: 1;\n    }\n  }\n  animation: fadeInFromNone 0.5s ease-out;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  z-index: 1000;\n\n  & > img {\n    background: white;\n  }\n'], ['\n  @keyframes fadeInFromNone {\n    0% {\n      display: none;\n      opacity: 0;\n    }\n\n    1% {\n      display: flex;\n      opacity: 0;\n    }\n\n    100% {\n      display: flex;\n      opacity: 1;\n    }\n  }\n  animation: fadeInFromNone 0.5s ease-out;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 40px;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  z-index: 1000;\n\n  & > img {\n    background: white;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: inline-block;\n  position: relative;\n  background-image: url(', ');\n  background-size: contain;\n  background-repeat: no-repeat;\n  & > img {\n    width: 100%;\n    height: auto;\n    min-height: auto;\n    max-width: 100%;\n    max-height: 100%;\n  }\n'], ['\n  display: inline-block;\n  position: relative;\n  background-image: url(', ');\n  background-size: contain;\n  background-repeat: no-repeat;\n  & > img {\n    width: 100%;\n    height: auto;\n    min-height: auto;\n    max-width: 100%;\n    max-height: 100%;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 5%;\n  left: 5%;\n  bottom: 5%;\n  right: 5%;\n  background: rgba(0, 0, 0, 0);\n  cursor: pointer;\n'], ['\n  position: absolute;\n  top: 5%;\n  left: 5%;\n  bottom: 5%;\n  right: 5%;\n  background: rgba(0, 0, 0, 0);\n  cursor: pointer;\n']);

import unionClassNames from 'union-class-names';
import React, { Component } from 'react';
import styled from 'styled-components';
import FaFileImage from 'react-icons/lib/fa/file-image-o';

export var handlePaste = function handlePaste(e) {
  var items = (e.clipboardData || e.originalEvent.clipboardData).items;
  for (var i = 0; i < items.length; i++) {
    if (items[i].type.indexOf('image') === 0) {
      var blob = items[i].getAsFile();
      if (blob !== null) {
        // we stop propagation in order to avoid Draft auto-inserting
        // a camera emoji (wtf)
        e.stopPropagation();
        e.preventDefault();
        return blob;
      }
    }
  }
};

/**
 * Copied from
 * https://github.com/draft-js-plugins/draft-js-plugins/blob/master/draft-js-image-plugin/src/Image/index.js
 * allows to render images for our editor ; only difference is we pass the src as a prop
 */
var ImageDetail = styled.div(_templateObject);

var ImageBody = styled.div(_templateObject2, function (_ref) {
  var image = _ref.image;
  return image;
});

var ClickOverlay = styled.div(_templateObject3);

export var Image = function (_Component) {
  _inherits(Image, _Component);

  function Image() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Image);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Image.__proto__ || Object.getPrototypeOf(Image)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      showDetail: false,
      init: true,
      style: {}

      /* 
        Thank you draft-js-plugins-resize for imposing a default height/width of 40px.
        This function overrides this, only at init, so we keep track with 'init' of whether the 
        image has already been resized or not.
      */
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Image, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          block = _props.block,
          className = _props.className,
          _props$theme = _props.theme,
          theme = _props$theme === undefined ? {} : _props$theme,
          uploads = _props.uploads,
          otherProps = _objectWithoutProperties(_props, ['block', 'className', 'theme', 'uploads']);

      // leveraging destructuring to omit certain properties from props


      var blockProps = otherProps.blockProps,
          customStyleMap = otherProps.customStyleMap,
          customStyleFn = otherProps.customStyleFn,
          decorator = otherProps.decorator,
          forceSelection = otherProps.forceSelection,
          offsetKey = otherProps.offsetKey,
          selection = otherProps.selection,
          tree = otherProps.tree,
          style = otherProps.style,
          contentState = otherProps.contentState,
          blockStyleFn = otherProps.blockStyleFn,
          elementProps = _objectWithoutProperties(otherProps, ['blockProps', 'customStyleMap', 'customStyleFn', 'decorator', 'forceSelection', 'offsetKey', 'selection', 'tree', 'style', 'contentState', 'blockStyleFn']);

      var data = contentState.getEntity(block.getEntityAt(0)).getData();
      var upload = uploads.find(function (x) {
        return x ? x.fileId === data.src.fileId : false;
      });
      var src = upload && upload.thumbnailDownloadURL;
      var detailSrc = upload && upload.fileDownloadURL;
      var combinedClassName = unionClassNames(theme.image, className);
      return React.createElement(
        ImageBody,
        _extends({ draggable: 'true', className: combinedClassName, style: this.state.style }, elementProps),
        React.createElement('img', { src: src }),
        React.createElement(ClickOverlay, {
          onClick: function onClick() {
            _this2.setState({ showDetail: true });
          }
        }),
        this.state.showDetail && React.createElement(
          ImageDetail,
          {
            onClick: function onClick(e) {
              e.stopPropagation();
              e.preventDefault();
              _this2.setState({ showDetail: false });
            } },
          React.createElement('img', { src: detailSrc, role: 'presentation' })
        )
      );
    }
  }]);

  return Image;
}(Component);

Image.getDerivedStateFromProps = function (nextProps, prevState) {
  var style = nextProps.style;
  var init = prevState.init;

  if (style.width === '40px' && style.height === '40px') {
    if (init) {
      var overridenStyle = _extends({}, style, { width: null, height: null });
      return { style: overridenStyle };
    } else {
      return { style: style };
    }
  } else {
    if (init) {
      return { init: false, style: style };
    } else {
      return { style: style };
    }
  }
};

export var ImageAddButton = function (_React$Component) {
  _inherits(ImageAddButton, _React$Component);

  function ImageAddButton() {
    var _ref3,
        _this4 = this;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, ImageAddButton);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref3 = ImageAddButton.__proto__ || Object.getPrototypeOf(ImageAddButton)).call.apply(_ref3, [this].concat(args))), _this3), _this3.handleUpload = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this3.props.onImageUpload(file);

              case 3:
                _context.next = 7;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context['catch'](0);

              case 7:
                _context.prev = 7;

                // clear input for subsequent uploads
                _this3.fileInput.value = null;
                return _context.finish(7);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[0, 5, 7, 10]]);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }(), _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(ImageAddButton, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      return React.createElement(
        'button',
        { className: 'draftJsToolbar__button__qi1gf', onClick: function onClick() {
            return _this5.fileInput.click();
          } },
        React.createElement(FaFileImage, { size: 14 }),
        React.createElement('input', {
          type: 'file',
          accept: 'image/*',
          multiple: false,
          style: { display: 'none' },
          ref: function ref(x) {
            return _this5.fileInput = x;
          },
          onChange: function onChange(e) {
            return _this5.handleUpload(e.target.files[0]);
          }
        })
      );
    }
  }]);

  return ImageAddButton;
}(React.Component);
//# sourceMappingURL=images.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/DraftEditor/plugins/images.js
// module id = 990
// module chunks = 0